import { useTheme } from '@mui/material/styles';
import AvailabilitySlotValue from '../common/AvailabilitySlotValue';
import TimelineBase from '../common/TimelineBase';

function TimeLineAxe({
  times,
  renderAvailableSlots,
  slotWidth = 140,
  showTimeRow,
  showSlotRows,
  hideTimeRow,
}) {
  const theme = useTheme();
  const slotBg =
    theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800];

  const renderSlotRows = ({ times }) => (
    <div style={{ display: 'flex', overflowX: 'visible', marginBottom: '0px' }}>
      {times.map(time => (
        <div
          key={time.i + 's0'}
          style={{
            minWidth: `${slotWidth}px`,
            textAlign: 'center',
            backgroundColor: slotBg,
            fontWeight: 'bold',
            color: theme.palette.text.primary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <div
            style={{
              width: '9ch',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
            }}
          >
            <AvailabilitySlotValue
              count={time.s0}
              freeText={`${time.frees0} Bahnen frei`}
              isWarning={time.frees0 < 0}
            />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <TimelineBase
      times={times}
      slotWidth={slotWidth}
      renderSlotRows={renderSlotRows}
      renderAvailableSlots={renderAvailableSlots}
      showTimeRow={showTimeRow}
      showSlotRows={showSlotRows}
      hideTimeRow={hideTimeRow}
    />
  );
}

export default TimeLineAxe;
